import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Snackbar,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../../CustomComponents/CustomButton";
import CustomConfirmationDialog from "../../../CustomComponents/CustomConfirmationDialog";
import CustomSnackBar from "../../../CustomComponents/CustomSnackBar";
import DisbursementTabIntegrator from "../Disbursement_Common/DisbursementTabIntegrator";
import NoSpecialAccess from "../../../CustomComponents/NoSpecialAccess";
import { SpecialAccessDetailAction } from "../../../Store/SpecialAccess/SpecialAccessDetailReducer";
import StlapFooter from "../../../CustomComponents/StlapFooter";
import store from "../../../Store";
import { DisbursementBalanceTransferReducerAction } from "../../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import GetBranchDetailsWithCode from "../../../CustomComponents/GetBranchDetailsWithCode";
import { useRef } from "react";
import { CommonShortCutAction } from "../../../Store/CommonShortCutsReducer";
import ChequeHandOverAllocationOrAuthorizeGrid from "../Disbursement_Common/ChequeHandOverAllocationOrAuthorizeGrid";
import { SpinnerReduerAction } from "../../../Store/spinner/SpinnerReducer";
import ConvertBase64ToFile from "../../../CustomComponents/ConvertBase64ToFile";
import { DisbursementLosCustomerDataReducerAction } from "../../../Store/DisbursementLosCustomerData/DisbursementLosCustomerDataReducer";

var today = new Date();
var todayDate =
  today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();

var disbursementDetailsInitialState = {
  applicationNum: "",
  billingDate: "",
  billDay: "-1",
  dateOfDisb: todayDate,
  disbAmt: 0,
  disbCycleNum: 0,
  transactionKey: 0,
  disbHeaderKey: 0,
  disbursementFavours: [],
  earlierDisbAmt: 0,
  editLock: false,
  effectiveDate: todayDate,
  emiCommDate: dayjs(today).format("MM/DD/YYYY"),
  firstEmiDueDate: "-1",
  paymentMode: "RTGS",
  remarks: "",
  approvalRemarks: "",
  requestStatus: "",
  screenMode: "CREATE",
  shflBank: "",
  totalDisbAmt: 0,
  rateOfInterest: 0,
  totalDeductionAmt: 0,
  disbEmiAmt: 0,
  sanctionedEmiAmt: 0,
};

const DisbursementModify = (props) => {
  var today = new Date();
  var currentDateValue = new Date(today.setHours(0, 0, 0, 0));

  const losCustomerData = useSelector(
    (state) => state.disbursementLosCustomerData.losCustomerData
  );

  const [billDayValues, setbillDayValues] = useState([]);
  const [deductionTabValue, setdeductionTabValue] = useState({});
  const [deductionTabSaveValue, setdeductionTabSaveValue] = useState({});
  const [pageloading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );
  const [showConfirmation, setshowConfirmation] = useState(false);
  const [saveData, setsaveData] = useState([]);
  const [showSnackBar, setshowSnackBar] = useState(false);
  const [snackBarMessage, setsnackBarMessage] = useState("");
  const [snackBarMessageColorType, setsnackBarMessageColorType] =
    useState("green");
  const [snackBarMessageType, setsnackBarMessageType] = useState("success");
  const [parameterValues, setparameterValues] = useState({});
  const [dialogMessage, setdialogMessage] = useState("Update this Request?");
  const [feeDataResponse, setfeeDataResponse] = useState({});
  const userName = useSelector((state) => state.branch.userName);
  const [historyData, setHistorydata] = useState({});
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  const deleteOperationActive = useSelector(
    (state) => state.disbursementBalanceTransfer.deleteOperationActive
  );
  const totalDeductionsTabLoadingActive = useSelector(
    (state) => state.disbursementBalanceTransfer.totalDeductionsTabLoadingActive
  );
  const chequeHandOverOrAuthorizeDlgData = useSelector(
    (state) =>
      state.disbursementBalanceTransfer.chequeHandOverOrAuthorizeDlgData
  );

  //SnackBar Handler for Cheque HandOver or Authorization.
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatchAction = useDispatch();

  //shortcut key
  const backRef = useRef(null);
  const saveRef = useRef(null);
  const deleteRef = useRef(null);
  const approveRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      backRef: backRef,
      saveRef: saveRef,
      deleteRef: deleteRef,
      approveRef: approveRef,
    };
    if (event.ctrlKey) {
      dispatchAction(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "disbursementModify",
        })
      );
      //}
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatchAction(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementModify",
        })
      );
    }
  };

  const screenFields = {
    applicationNum: "applicationNum",
    billingDate: "billingDate",
    billDay: "billDay",
    dateOfDisb: "dateOfDisb",
    disbAmt: "disbAmt",
    disbCycleNum: "disbCycleNum",
    transactionKey: "transactionKey",
    disbHeaderKey: "disbHeaderKey",
    disbursementFavours: "disbursementFavours",
    earlierDisbAmt: "earlierDisbAmt",
    editLock: "editLock",
    effectiveDate: "effectiveDate",
    emiCommDate: "emiCommDate",
    firstEmiDueDate: "firstEmiDueDate",
    paymentMode: "paymentMode",
    remarks: "remarks",
    approvalRemarks: "approvalRemarks",
    requestStatus: "requestStatus",
    shflBank: "shflBank",
    totalDisbAmt: "totalDisbAmt",
    transactionId: "transactionId",
    screenMode: "screenMode",
    rateOfInterest: "rateOfInterest",
    totalDeductionAmt: "totalDeductionAmt",
    disbEmiAmt: "disbEmiAmt",
    sanctionedEmiAmt: "sanctionedEmiAmt",
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case screenFields.billingDate:
        return { ...state, billingDate: action.value };
      case screenFields.billDay:
        return { ...state, billDay: action.value };
      case screenFields.dateOfDisb:
        return { ...state, dateOfDisb: action.value };
      case screenFields.disbAmt:
        return { ...state, disbAmt: action.value };
      case screenFields.disbCycleNum:
        return { ...state, disbCycleNum: action.value };
      case screenFields.transactionKey:
        return { ...state, transactionKey: action.value };
      case screenFields.disbursementFavours:
        return { ...state, disbursementFavours: action.value };
      case screenFields.earlierDisbAmt:
        return { ...state, earlierDisbAmt: action.value };
      case screenFields.editLock:
        return { ...state, editLock: action.value };
      case screenFields.effectiveDate:
        return { ...state, effectiveDate: action.value };
      case screenFields.emiCommDate:
        const dateValue = action.value
          ? dayjs(action.value).format("MM/DD/YYYY")
          : null;
        return { ...state, emiCommDate: dateValue };
      case screenFields.firstEmiDueDate:
        return { ...state, firstEmiDueDate: action.value };
      case screenFields.paymentMode:
        return { ...state, paymentMode: action.value };
      case screenFields.remarks:
        return { ...state, remarks: action.value };
      case screenFields.approvalRemarks:
        return { ...state, approvalRemarks: action.value };
      case screenFields.requestStatus:
        return { ...state, requestStatus: action.value };
      case screenFields.shflBank:
        return { ...state, shflBank: action.value };
      case screenFields.totalDisbAmt:
        return { ...state, totalDisbAmt: action.value };
      case screenFields.screenMode:
        return { ...state, screenMode: action.value };
      case screenFields.rateOfInterest:
        return { ...state, rateOfInterest: action.value };
      case screenFields.totalDeductionAmt:
        return { ...state, totalDeductionAmt: action.value };
      case "FullMap":
        return { ...action.value };
      case screenFields.disbEmiAmt:
        return { ...state, disbEmiAmt: action.value };
      case screenFields.sanctionedEmiAmt:
        return { ...state, sanctionedEmiAmt: action.value };
      // default:
      //   return { ...disbursementDetailsInitialState };
    }
  };
  /* special Access */
  const programId = useSelector((state) => state.specialAccess.programId);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  useEffect(() => {
    getModeData();
  }, []);

  const getModeData = async () => {
    let modeIdVal = "";
    switch (props.screenMode) {
      case "APPROVE":
        modeIdVal = "DB03-A";
        break;
      case "MODIFY":
        modeIdVal = "DB02-M";
        break;
      case "CANCEL":
        modeIdVal = "DB02-C";
        break;
      default:
        break;
    }
    const response = await axios.get("/specialAccess/getModeSpecialAccess", {
      method: "get",
      params: {
        userId: userId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatchAction(SpecialAccessDetailAction.getModeData(response.data));
  };

  const modeAccessMap = useSelector(
    (state) => state.specialAccess.modeAccessMap
  );

  const viewValue = modeAccessMap && modeAccessMap.disbursementView;
  const [disbursementDetailTabValue, dispatch] = useReducer(
    reducer,
    location.state
  );
  const errorParameters = {
    currentDisbError: "currentDisbError",
    roiError: "roiError",
    feddError: "feddError",
    billDayError: "billDayError",
    shflBankError: "shflBankError",
    bankAccountError: "bankAccountError",
    dateOfDisbError: "dateOfDispError",
    overAllError: "overAllError",
    remarksError: "remarksError",
    approvalRemarksError: "approvalRemarksError",
  };

  const errorInitialState = {
    currentDisbError: [false, "Current Disbursement Amount Cannot be Zero."],
    roiError: [false, "Rate of Interest Cannot be Empty/Zero."],
    feddError: [false, "Please Select Billing Date."],
    billDayError: [false, "Please Select Billing Day."],
    shflBankError: [false, "SHFL Bank Cannot be Empty."],
    bankAccountError: [false, ""],
    dateOfDisbError: [false, "Please Select Date of Disbursement"],
    overAllError: false,
    approvalRemarksError: [
      false,
      "Please Enter Approval Remarks less than 4000 characters.",
    ],
    remarksError: [false, "Please Enter Remarks less than 4000 characters."],
  };

  const errorReducer = (state, action) => {
    switch (action.type) {
      case errorParameters.currentDisbError:
        return { ...state, currentDisbError: action.value };
      case errorParameters.roiError:
        return { ...state, roiError: action.value };
      case errorParameters.feddError:
        return { ...state, feddError: action.value };
      case errorParameters.billDayError:
        return { ...state, billDayError: action.value };
      case errorParameters.shflBankError:
        return { ...state, shflBankError: action.value };
      case errorParameters.bankAccountError:
        return { ...state, bankAccountError: action.value };
      case errorParameters.dateOfDisbError:
        return { ...state, dateOfDisbError: action.value };
      case errorParameters.overAllError:
        return { ...state, overAllError: action.value };
      case errorParameters.remarksError:
        return { ...state, remarksError: action.value };
      case errorParameters.approvalRemarksError:
        return { ...state, approvalRemarksError: action.value };
      default:
        return { ...errorInitialState };
    }
  };

  const [errorState, errorDispatch] = useReducer(
    errorReducer,
    errorInitialState
  );

  useEffect(() => {
    getCustomerDataByAppNum();
    getBillingDayData();
    getDeductionTabData();
    getParameterValues();
    dispatch({
      type: screenFields.screenMode,
      value: props.screenMode,
    });
    setTimeout(() => {
      setPageLoading(false);
      setLoading(false);
      setLoadingMsg("");
    }, 500);

    window.addEventListener("beforeunload", alertUser);
    window.addEventListener("unload", handleTabClosing);

    return () => {
      // on component unmount reset the balance transfer records.
      dispatchAction(
        DisbursementLosCustomerDataReducerAction.resetToInitialState()
      );
      dispatchAction(DisbursementBalanceTransferReducerAction.resetGridRows());
      dispatchAction(
        DisbursementBalanceTransferReducerAction.resetToInitialState()
      );
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          null
        )
      );
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("unload", handleTabClosing);
      // event to call extra for default on component unmount on navigate using sidemenu was below.
      handleTabClosing();
    };
  }, []);

  const handleTabClosing = async () => {
    const response = await axios.post("/disbursement/editLockUpdate", {
      disbCycleNum: disbursementDetailTabValue.disbCycleNum,
      applicationNum: disbursementDetailTabValue.applicationNum,
      screenMode: props.screenMode,
    });
  };

  const alertUser = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  const getBillingDayData = async () => {
    // const response = await axios.get(
    //   "/disbursement/getAllDisbursementBillingDayData"
    // );
    // Instead of getting values from Disbursement API we should get the values from the LOV MASTER API.
    const disbursementLovValues = await axios.post("/lovMaster/getLovValues", {
      moduleId: "MD001",
    });
    const lovData = disbursementLovValues.data;
    const billDayValues = lovData?.["Billing Day"].map((billDay) => {
      return {
        id: billDay.lovOrder,
        value: billDay.lovValues,
        text: billDay.lovValues,
      };
    });
    setbillDayValues(billDayValues);
  };
  const getCustomerDataByAppNum = async () => {
    const response = await axios.post("/losCustomer/getCustomerDataByAppNum", {
      applicationNum: location.state.applicationNum,
    });
    if (response.status === 200) {
      dispatchAction(
        DisbursementLosCustomerDataReducerAction.setLosCustomerData(
          response.data
        )
      );
    }
  };

  const getDeductionTabData = async () => {
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductions(0)
    );
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductionsTabLoadingActive(
        true
      )
    );
    const response = await axios.post("/additionalfee/getFeeData", {
      applicationNum: location.state.applicationNum,
      type: "accrual",
    });
    let paidTotal1 = 0;
    let dueTotal1 = 0;
    let deductionTotal1 = 0;
    let waivedTotal1 = 0;
    let data = {};
    let saveData = [];
    response.data.gridData.map((rows) => {
      data = {};
      let saveData1 = {};
      saveData1 = {
        applicationNum: location.state.applicationNum,
        received:
          rows.received + (rows.receiveable - rows.received - rows.earlyWaiver),
        details: rows.details,
      };
      saveData.push(saveData1);
      paidTotal1 = paidTotal1 + rows.received;
      dueTotal1 = dueTotal1 + rows.receiveable;
      deductionTotal1 =
        deductionTotal1 + (rows.receiveable - rows.received - rows.earlyWaiver);
      waivedTotal1 = waivedTotal1 + rows.earlyWaiver;
    });
    data.paidTotal = paidTotal1;
    data.dueTotal = dueTotal1 - data.paidTotal;
    data.deductionTotal = deductionTotal1;
    data.waivedTotal = waivedTotal1;
    data.accrualTotal = data.deductionTotal;
    data.gridRows = response.data.gridData;
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductions(
        Number(data.deductionTotal) <= 0 ? 0 : data.deductionTotal
      )
    );
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductionsTabLoadingActive(
        false
      )
    );
    setdeductionTabValue(data);
    setfeeDataResponse(response.data);
    setdeductionTabSaveValue(saveData);
  };

  const getParameterValues = async () => {
    const response = await axios.get("/parameter/getAllParameterData");
    const dataMap = {};
    response.data.map((parameter) => {
      dataMap[parameter.paramName] = parameter;
    });
    setparameterValues(dataMap);
  };

  const fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "DB02-M";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatchAction(SpecialAccessDetailAction.getFieldData(response.data));
  };

  const validateCreateRequestData = (data, losData) => {
    var status = true;

    //Validating Current Disbursement Amount Field
    if (
      data.disbAmt === 0 ||
      data.disbAmt === null ||
      data.disbAmt === "" ||
      data.disbAmt === "0" ||
      data.disbAmt === "00"
    ) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [true, "Current Disbursement Amount Cannot be Zero."],
      });
      status = false;
    } else if (
      Math.floor(data.disbAmt + data.earlierDisbAmt) >
      Math.floor(losData.sanctionAmt)
    ) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [
          true,
          "Sum of Current Disbursement Amount & Earlier Disbursement Amount Cannot be Greater than Sanctioned Loan Amount.",
        ],
      });
      status = false;
    } else if (data.totalDisbAmt <= 0) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [
          true,
          "Current Disbursement Amount Cannot be Less than or Equal to Total Deductions.",
        ],
      });
      status = false;
    } else if (
      parameterValues &&
      Object.keys(parameterValues).length > 0 &&
      parameterValues["Disbursement Minimum Amount"] &&
      new Date(
        parameterValues["Disbursement Minimum Amount"]["paramEffStartDate"]
      ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
      new Date(
        parameterValues["Disbursement Minimum Amount"]["paramEffEndDate"]
      ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
      Math.floor(data.disbAmt) <
        Number(parameterValues["Disbursement Minimum Amount"]["paramValue"])
    ) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [
          true,
          "Current Disbursement Amount Cannot be Less than Minimum Disbursement Amount given in Parameter.",
        ],
      });
      status = false;
    } else if (errorState.currentDisbError[0]) {
      errorDispatch({
        type: errorParameters.currentDisbError,
        value: [false, "Current Disbursement Amount Cannot be Zero."],
      });
    }

    if (props.screenMode === "MODIFY") {
      // validate only for modify mode & not to validate for approval or cancel mode since the disb date is disabled.
      // Validation Date of Disbursement
      errorDispatch({
        type: errorParameters.dateOfDisbError,
        value: [false, "Date of Disbursement Cannot be Empty."],
      });

      let minDateValue = Number(0);
      let maxDateValue = Number(0);
      if (
        parameterValues !== null &&
        parameterValues !== undefined &&
        parameterValues &&
        Object.keys(parameterValues).length > 0
      ) {
        minDateValue =
          fieldAccessMap &&
          (fieldAccessMap.requestDateModifyBackCount &&
          parameterValues["Disbursement Modify Request Date Back Count"]
            ? Number(
                parameterValues["Disbursement Modify Request Date Back Count"][
                  "paramValue"
                ]
              )
            : 0);
        maxDateValue =
          fieldAccessMap &&
          (fieldAccessMap.requestDateModifyFutureCount &&
          parameterValues["Disbursement Modify Request Date Future Count"]
            ? Number(
                parameterValues[
                  "Disbursement Modify Request Date Future Count"
                ]["paramValue"]
              )
            : 0);
      }
      const dateOfDisbValue = data.dateOfDisb;
      let formattedValue = dateOfDisbValue;
      if (dateOfDisbValue === 0 || dateOfDisbValue === null) {
        errorDispatch({
          type: errorParameters.dateOfDisbError,
          value: [true, "Date of Disbursement Cannot be Empty."],
        });
        status = false;
      } else if (new Date(formattedValue).toDateString() === "Invalid Date") {
        errorDispatch({
          type: errorParameters.dateOfDisbError,
          value: [true, "Please Enter Valid Disbursement Date."],
        });
        status = false;
      } else {
        // valid date then go for the validation.
        if (
          new Date(formattedValue) >=
          new Date(dayjs(new Date()).format("MM/DD/YYYY"))
        ) {
          if (
            parameterValues &&
            Object.keys(parameterValues).length > 0 &&
            parameterValues["Disbursement Modify Request Date Future Count"] &&
            new Date(
              parameterValues["Disbursement Modify Request Date Future Count"][
                "paramEffStartDate"
              ]
            ) <= currentDateValue &&
            new Date(
              parameterValues["Disbursement Modify Request Date Future Count"][
                "paramEffEndDate"
              ]
            ) >= currentDateValue &&
            new Date(formattedValue) >
              new Date(new Date().setDate(new Date().getDate() + maxDateValue))
          ) {
            errorDispatch({
              type: errorParameters.dateOfDisbError,
              value: [
                true,
                "Date of Disbursement Cannot be greater than Request Date Future count from Current Date.",
              ],
            });
            status = false;
          } else {
            // check for current disb date out of the effective start & end dates.
            const currentDate = new Date(
              dayjs(new Date()).format("MM/DD/YYYY")
            );
            if (
              !(
                parameterValues[
                  "Disbursement Modify Request Date Future Count"
                ] &&
                new Date(
                  parameterValues[
                    "Disbursement Modify Request Date Future Count"
                  ]["paramEffStartDate"]
                ) <= currentDateValue &&
                new Date(
                  parameterValues[
                    "Disbursement Modify Request Date Future Count"
                  ]["paramEffEndDate"]
                ) >= currentDateValue
              ) &&
              new Date(formattedValue).toDateString() !==
                new Date(currentDate).toDateString()
            ) {
              errorDispatch({
                type: errorParameters.dateOfDisbError,
                value: [
                  true,
                  "Date of Disbursement Cannot be greater than Request Date Future count from Current Date.",
                ],
              });
              status = false;
            }
          }
        } else {
          if (
            parameterValues &&
            Object.keys(parameterValues).length > 0 &&
            parameterValues["Disbursement Modify Request Date Back Count"] &&
            new Date(
              parameterValues["Disbursement Modify Request Date Back Count"][
                "paramEffStartDate"
              ]
            ) <= currentDateValue &&
            new Date(
              parameterValues["Disbursement Modify Request Date Back Count"][
                "paramEffEndDate"
              ]
            ) >= currentDateValue &&
            new Date(formattedValue) <
              new Date(
                new Date(
                  new Date().setDate(new Date().getDate() - minDateValue)
                ).setHours(0, 0, 0, 0)
              )
          ) {
            errorDispatch({
              type: errorParameters.dateOfDisbError,
              value: [
                true,
                "Date of Disbursement Cannot be lesser than Request Date Back count from Current Date.",
              ],
            });
            status = false;
          } else {
            // check for current disb date out of the effective start & end dates.
            const currentDate = new Date(
              dayjs(new Date()).format("MM/DD/YYYY")
            );
            if (
              !(
                parameterValues[
                  "Disbursement Modify Request Date Back Count"
                ] &&
                new Date(
                  parameterValues[
                    "Disbursement Modify Request Date Back Count"
                  ]["paramEffStartDate"]
                ) <= currentDateValue &&
                new Date(
                  parameterValues[
                    "Disbursement Modify Request Date Back Count"
                  ]["paramEffEndDate"]
                ) >= currentDateValue
              ) &&
              new Date(formattedValue).toDateString() !==
                new Date(currentDate).toDateString()
            ) {
              errorDispatch({
                type: errorParameters.dateOfDisbError,
                value: [
                  true,
                  "Date of Disbursement Cannot be lesser than Request Date Back count from Current Date.",
                ],
              });
              status = false;
            }
          }
        }
      }
    }

    //Validating FEDD Field
    if (
      data.firstEmiDueDate === "-1" ||
      data.firstEmiDueDate === null ||
      data.firstEmiDueDate === undefined ||
      data.firstEmiDueDate === ""
    ) {
      errorDispatch({
        type: errorParameters.feddError,
        value: [true, "Please Select FEDD Date."],
      });
      status = false;
    } else if (errorState.feddError[0]) {
      errorDispatch({
        type: errorParameters.feddError,
        value: [false, "Please Select FEDD Date."],
      });
    }

    //Validating Billing  Day Field
    if (
      data.billDay === "-1" ||
      data.billDay === null ||
      data.billDay === undefined ||
      data.billDay === ""
    ) {
      errorDispatch({
        type: errorParameters.billDayError,
        value: [true, "Please Select Billing Day."],
      });
      status = false;
    } else if (errorState.billDayError[0]) {
      errorDispatch({
        type: errorParameters.billDayError,
        value: [false, "Please Select Billing Day."],
      });
    }

    // validating remarks fields length.
    if (props.screenMode === "CANCEL") {
      // remarks is required field in cancel mode.
      if (
        data.remarks === "" ||
        data.remarks === null ||
        data.remarks === undefined ||
        String(data.remarks).length === 0
      ) {
        errorDispatch({
          type: errorParameters.remarksError,
          value: [true, "Please Enter Remarks."],
        });
        status = false;
      } else {
        errorDispatch({
          type: errorParameters.remarksError,
          value: [false, "Please Enter Remarks."],
        });
      }
    }

    if (props.screenMode === "APPROVE") {
      // approval remarks is required field in approval mode.
      if (
        data.approvalRemarks === "" ||
        data.approvalRemarks === null ||
        data.approvalRemarks === undefined ||
        String(data.approvalRemarks).length === 0
      ) {
        errorDispatch({
          type: errorParameters.approvalRemarksError,
          value: [true, "Please Enter Approval Remarks."],
        });
        status = false;
      } else {
        errorDispatch({
          type: errorParameters.approvalRemarksError,
          value: [false, "Please Enter Approval Remarks."],
        });
      }
    }

    if (data.remarks && String(data.remarks).length > 4000) {
      errorDispatch({
        type: errorParameters.remarksError,
        value: [true, "Please Enter Remarks less than 4000 Characters."],
      });
      status = false;
    }
    if (data.approvalRemarks && String(data.approvalRemarks).length > 4000) {
      errorDispatch({
        type: errorParameters.approvalRemarksError,
        value: [
          true,
          "Please Enter Approval Remarks less than 4000 Characters.",
        ],
      });
      status = false;
    }

    if (
      losData.creditDeviationStatus !== "Approved" ||
      losData.legalDeviationStatus !== "Approved" ||
      losData.techinicalDeviationStatus !== "Approved" ||
      losData.rcuStatus !== "Approved"
    ) {
      status = false;
      setMessage(
        "Unable to Proceed due to Few Conditions & Deviations are Not Approved."
      );
      setAlertType("error");
      openAlertHandler();
    }

    let gridValidationStatus = true;
    if (props.screenMode === "MODIFY") {
      //Validating Balance Transfer Grid.
      gridValidationStatus = validateBalanceTransferGrid(data, false);
    }

    return status && gridValidationStatus;
  };

  const validateBalanceTransferGrid = (data, gridAddBtnClick) => {
    let status = true;
    errorDispatch({
      type: errorParameters.bankAccountError,
      value: [false, ""],
    });
    let errorMessage = "";

    // get the latest records from store.
    const balanceTransferRecords =
      store.getState().disbursementBalanceTransfer.gridRows;

    if (balanceTransferRecords.length === 0) {
      errorMessage =
        `${errorMessage}` + `${`Please Add Balance Transfer Records.`}\n`;
      errorDispatch({
        type: errorParameters.bankAccountError,
        value: [true, errorMessage],
      });
      status = false;
    } else {
      // balance transfer records > 0
      let errorExist = false;
      balanceTransferRecords.forEach((record) => {
        if (record.favouringName === null || record.favouringName === "") {
          errorExist = true;
        }
        if (
          record.amount === null ||
          record.amount === "" ||
          record.amount === "0" ||
          record.amount === 0
        ) {
          errorExist = true;
        }

        if (record.bankBranchGl === null || record.bankBranchGl === "") {
          errorExist = true;
        }

        if (record.paymentMode === "CHEQUE") {
          if (record.chequeMode === null || record.chequeMode === "") {
            errorExist = true;
          }
          if (record.chequePrintAt === null || record.chequePrintAt === "") {
            errorExist = true;
          }
          if (
            (record.chequePrintAt === null || record.chequePrintAt === "") &&
            (record.chequePrintLocation === null ||
              record.chequePrintLocation === "")
          ) {
            errorExist = true;
          }
          if (
            (record.chequePrintAt === null || record.chequePrintAt === "") &&
            (record.chequeShflLocation === null ||
              record.chequeShflLocation === "")
          ) {
            errorExist = true;
          }
          if (
            record.chequeShflLocation !== null &&
            record.chequeShflLocation !== "" &&
            (record.chequeAllocationMode === null ||
              record.chequeAllocationMode === "")
          ) {
            errorExist = true;
          }
          if (
            record.chequeAllocationMode !== null &&
            record.chequeAllocationMode !== "" &&
            record.chequeAllocationMode !== "AUTO" &&
            (record.bankBranchShflBank === null ||
              record.bankBranchShflBank === "")
          ) {
            errorExist = true;
          }
        } else if (record.paymentMode === "DD") {
          if (record.chequeMode === null || record.chequeMode === "") {
            errorExist = true;
          }
          if (record.chequePrintAt === null || record.chequePrintAt === "") {
            errorExist = true;
          }
          if (record.payableAt === null || record.payableAt === "") {
            errorExist = true;
          }
          if (
            record.bankBranchShflBank === null ||
            record.bankBranchShflBank === ""
          ) {
            errorExist = true;
          }
        } else if (
          record.paymentMode === "NEFT" ||
          record.paymentMode === "RTGS"
        ) {
          if (
            record.bankBranchShflBank === null ||
            record.bankBranchShflBank === ""
          ) {
            errorExist = true;
          }
          if (record.ifscCode === null || record.ifscCode === "") {
            errorExist = true;
          }

          if (record.bankName === null || record.bankName === "") {
            errorExist = true;
          }

          if (record.bankBranchName === null || record.bankBranchName === "") {
            errorExist = true;
          }

          if (record.bankAccountNum === null || record.bankAccountNum === "") {
            errorExist = true;
          }

          if (
            record.bankAccountType === null ||
            record.bankAccountType === ""
          ) {
            errorExist = true;
          }
        }
      });

      if (errorExist) {
        errorMessage =
          `${errorMessage}` + `${`Few Rows has Some Empty Data on Columns.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // validate the favouring name for Special characters & length > 80.
      let invalidFavouringNameWithSpecialCharExists = false;
      let invalidFavouringNameWithMaxlengthExists = false;
      const specialCharPatternForFavouringName = /[!@#$%^~&*()?,":{}|<>\\\-]/;
      // validate the bank Account number.
      let invalidAccountNumExits = false;
      // validate the Ifsc Code.
      let invalidIfscCodeExist = false;
      balanceTransferRecords.forEach((record) => {
        if (record.paymentMode === "NEFT" || record.paymentMode === "RTGS") {
          const bankAccountNum = record.bankAccountNum;
          if (
            bankAccountNum !== "" &&
            bankAccountNum !== null &&
            bankAccountNum !== undefined &&
            String(bankAccountNum).length <= 18 &&
            String(bankAccountNum).length >= 9 &&
            Number(bankAccountNum) > 0 &&
            !String(bankAccountNum).includes(".") &&
            /^\d+$/.test(bankAccountNum)
          ) {
            invalidAccountNumExits = false;
          } else {
            invalidAccountNumExits = true;
          }

          const ifscCode = record.ifscCode;
          if (
            ifscCode !== "" &&
            ifscCode !== null &&
            ifscCode !== undefined &&
            /^[A-Za-z0-9]*$/.test(ifscCode) &&
            String(ifscCode).length === 11
          ) {
            invalidIfscCodeExist = false;
          } else {
            invalidIfscCodeExist = true;
          }
        }

        // validating the favouring name irrespective of payment mode -> all modes have favouring name as editable.
        const favouringNameValue = record.favouringName;
        if (
          favouringNameValue &&
          specialCharPatternForFavouringName.test(favouringNameValue)
        ) {
          invalidFavouringNameWithSpecialCharExists = true;
        } else {
          invalidFavouringNameWithSpecialCharExists = false;
        }
        if (favouringNameValue && String(favouringNameValue).length > 80) {
          invalidFavouringNameWithMaxlengthExists = true;
        } else {
          invalidFavouringNameWithMaxlengthExists = false;
        }
      });

      if (invalidFavouringNameWithSpecialCharExists) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid Favouring Name with Special Characters.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (invalidFavouringNameWithMaxlengthExists) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid Favouring Name with max length Exceeding 80 Characters.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (invalidAccountNumExits) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid Bank Account Number.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (invalidIfscCodeExist) {
        errorMessage =
          `${errorMessage}` + `${`Few Rows has Invalid Ifsc Code.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // // validate shfl branch column based on cheque allocation mode.
      // let bankBranchShflBankError = false;
      // balanceTransferRecords.forEach((record) => {
      //   if (
      //     record.chequeAllocationMode !== null &&
      //     record.chequeAllocationMode !== "" &&
      //     record.chequeAllocationMode === "AUTO" &&
      //     record.bankBranchShflBank !== null &&
      //     record.bankBranchShflBank !== ""
      //   ) {
      //     bankBranchShflBankError = true;
      //   }
      // });

      // if (bankBranchShflBankError) {
      //   errorMessage =
      //     `${errorMessage}` +
      //     `${`Few Rows has Invalid Bank Branch ShflBank for cheque Allocation Mode Auto .`}\n`;
      //   errorDispatch({
      //     type: errorParameters.bankAccountError,
      //     value: [true, errorMessage],
      //   });
      //   status = false;
      // }

      // validate the cheque Print Location & cheque Shfl location based on Cheque Print At.
      let chequePrintLocationError = false;
      balanceTransferRecords.forEach((record) => {
        if (
          record.chequePrintAt === "BANK" &&
          record.paymentMode === "CHEQUE" &&
          (record.chequePrintLocation === null ||
            record.chequePrintLocation === "")
        ) {
          chequePrintLocationError = true;
        }
        if (
          record.chequePrintAt === "CORPORATE" &&
          record.chequePrintLocation !== null &&
          record.chequePrintLocation !== ""
        ) {
          chequePrintLocationError = true;
        }

        if (
          record.chequePrintAt === "SHFL BRANCH" &&
          record.chequePrintLocation !== null &&
          record.chequePrintLocation !== ""
        ) {
          chequePrintLocationError = true;
        }
      });

      if (chequePrintLocationError) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid cheque Print Location.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // cheque Num validation case for cheque mode is Manual & Auto in create mode.
      let chequeNumError = false;
      balanceTransferRecords.forEach((record) => {
        if (record.paymentMode === "CHEQUE") {
          if (
            record.chequeMode === "MANUAL" &&
            (record.chequeNum === null ||
              record.chequeNum === "" ||
              String(record.chequeNum).length > 6)
          ) {
            chequeNumError = true;
          }
        }
      });

      if (chequeNumError) {
        errorMessage =
          `${errorMessage}` + `${`Few Rows has Invalid cheque Number.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      let chequeShflLocationError = false;
      balanceTransferRecords.forEach((record) => {
        if (
          record.chequePrintAt === "SHFL BRANCH" &&
          (record.chequeShflLocation === null ||
            record.chequeShflLocation === "")
        ) {
          chequeShflLocationError = true;
        }

        if (
          record.chequePrintAt === "BANK" &&
          record.chequeShflLocation !== null &&
          record.chequeShflLocation !== ""
        ) {
          chequeShflLocationError = true;
        }
        if (
          record.chequePrintAt === "CORPORATE" &&
          record.chequeShflLocation !== null &&
          record.chequeShflLocation !== ""
        ) {
          chequeShflLocationError = true;
        }
      });

      if (chequeShflLocationError) {
        errorMessage =
          `${errorMessage}` +
          `${`Few Rows has Invalid cheque SHFL Location.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      const zeroAmountRows = [...balanceTransferRecords].filter(
        (row) => Number(row.disbAmt) === 0
      );

      if (zeroAmountRows.length > 0) {
        errorMessage = `${errorMessage}` + `${`Few Rows has Zero Amount.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      // RTGS min validation.
      const rtgsAmountErrorRows = [...balanceTransferRecords].filter(
        (row) => row.paymentMode === "RTGS" && Number(row.disbAmt) < 200000
      );

      if (rtgsAmountErrorRows.length > 0) {
        errorMessage =
          `${errorMessage}` +
          `${`Minimum Amount for one RTGS Payment should be greater than 2,00,000 . Few Rows have Invalid Amount.`}\n`;
        errorDispatch({
          type: errorParameters.bankAccountError,
          value: [true, errorMessage],
        });
        status = false;
      }

      if (!gridAddBtnClick) {
        // for grid add btn click -> true skip this validation
        // for create btn click then gridAddBtnClick is -> false , then need to valdiate
        const sumTotalAmount = Number(
          [...balanceTransferRecords]
            .map((row) => Number(row.disbAmt))
            .reduce((a, b) => a + b)
        );
        const totalDisbAmt = data.disbAmt - data.totalDeductionAmt;

        if (sumTotalAmount > totalDisbAmt) {
          errorMessage =
            `${errorMessage}` +
            `${`Total Net Disbursement Amount to be Sent is Greater than `}` +
            `${parseInt(totalDisbAmt).toLocaleString("en-IN")}` +
            `\n`;
          errorDispatch({
            type: errorParameters.bankAccountError,
            value: [true, errorMessage],
          });
          status = false;
        } else if (sumTotalAmount < totalDisbAmt) {
          errorMessage =
            `${errorMessage}` +
            `${`Total Net Disbursement Amount to be Sent is Less than `}` +
            `${parseInt(totalDisbAmt).toLocaleString("en-IN")}` +
            `\n`;
          errorDispatch({
            type: errorParameters.bankAccountError,
            value: [true, errorMessage],
          });
          status = false;
        }
      }
    }
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateIsGridRecordsValid(status)
    );
    return status;
  };

  //validation CreditDebitMismatch
  const validateCreditDebitMismatch = async (disbData, losData) => {
    const params = {
      applicationNumber: losData.applicationNum,
      deduction: disbData.totalDeductionAmt,
    };
    try {
      let data;
      const response = await axios.post(
        "disbursement/validateCreditDebitMismatch",
        params
      );
      if (response.data) {
        data = response.data;
      }
      return data;
    } catch (error) {
      setMessage("Unable to proceed due to credit/debit mismatch");
      setAlertType("error");
      openAlertHandler();
      setLoading(false);
      throw new Error("Network error");
    }
  };

  const updateRequestHandler = async (disbursementData, losData) => {
    const validateStatus = validateCreateRequestData(disbursementData, losData);
    let status = true;
    if (props.screenMode === "MODIFY") {
      if (disbursementData.disbCycleNum > 1) {
        // validate a disbursement date from backend.
        try {
          const response = await axios.post(
            "/disbursement/disbursementDateValidation",
            {
              branch: losData.branch,
              applicationNum: losData.applicationNum,
              dateOfDisbursement: dayjs(disbursementData.dateOfDisb).format(
                "MM/DD/YYYY"
              ),
              disbCycleNum: disbursementData.disbCycleNum,
            }
          );
          if (response.status === 206) {
            // error
            errorDispatch({
              type: errorParameters.dateOfDisbError,
              value: [true, response.data],
            });
            status = false;
          }
        } catch (error) {
          status = false;
          setLoading(false);
        }
      }
    }
    let isValid = true;
    if (disbursementData.screenMode !== "CANCEL") {
      isValid = await validateCreditDebitMismatch(disbursementData, losData);
    }
    if (!isValid) {
      setMessage("Unable to proceed due to credit/debit mismatch");
      setAlertType("error");
      openAlertHandler();
      setLoading(false);
    } else if (isValid && validateStatus && status) {
      setLoadingMsg("Validated the Disbursement Data Successfully.....");
      let balanceTransferRecords =
        store.getState().disbursementBalanceTransfer.gridRows;
      const branchWithCodes = GetBranchDetailsWithCode();
      let overAllDisbRecordStatus = disbursementData.requestStatus;
      if (disbursementData.screenMode === "APPROVE") {
        overAllDisbRecordStatus = "Approved";
        setdialogMessage("Approve this Request?");
      } else if (disbursementData.screenMode === "CANCEL") {
        overAllDisbRecordStatus = "Cancelled";
        setdialogMessage("Cancel this Request?");
      }
      balanceTransferRecords = [...balanceTransferRecords].map((row) => {
        let record = { ...row };
        if (disbursementData.screenMode === "APPROVE") {
          record.requestStatus =
            record.paymentMode === "NEFT" ||
            record.paymentMode === "RTGS" ||
            record.paymentMode === "DD"
              ? "Approved"
              : "Approved , Cheque HandOver Pending";
        } else {
          record.requestStatus = disbursementData.requestStatus;
        }
        record.applicationNum = losData.applicationNum;
        record.totalDisbAmt = record.amount;
        record.deductionAmount = record.deductionAmount;
        record.disbAmt = record.disbAmt;
        record.accHoldrName = record.favouringName;
        record.createdBy = userName;
        record.createdDate = "";
        record.lastModifiedBy = userName;
        record.lastModifiedDate = "";
        record.bankBranch = record.bankBranchShflBank;
        if (
          props.screenMode === "APPROVE" &&
          record.chequePrintAt !== "SHFL BRANCH"
        ) {
          record.bankCode = "LFSL095";
          // branch code spec yet to be decided for corporate & bank.
          // for now using the user account selected branch for user account or
          // application branch will be same for now.
          const branchCodeValue = branchWithCodes.find((branch) => {
            return branch.code === losData.branchCode;
          });
          record.branchCode = branchCodeValue.code;
        }

        if (
          props.screenMode === "MODIFY" &&
          record.chequePrintAt === "SHFL BRANCH"
        ) {
          record.bankCode = "LFSL095";
          // for shfl branch value for cheque print At.
          const branchCodeValue = branchWithCodes.find((branch) => {
            return branch.label === record.chequeShflLocation;
          });
          record.branchCode = branchCodeValue.code;
        }
        return record;
      });
      disbursementData.disbursementFavours = balanceTransferRecords;
      const requestStatus = balanceTransferRecords.map(
        (record) => record.requestStatus
      );
      overAllDisbRecordStatus = requestStatus.includes(
        "Approved , Cheque HandOver Pending"
      )
        ? "Approved , Cheque HandOver Pending"
        : "Approved";
      const balanceTransferPaymentMode =
        store.getState().disbursementBalanceTransfer.currentRowPaymentMode;
      disbursementData.paymentMode = balanceTransferPaymentMode;
      const loanType = store.getState().disbursementBalanceTransfer.loanType;
      disbursementData.loanType = loanType;
      disbursementData.dateOfDisb = new Date(disbursementData.dateOfDisb);
      disbursementData.effectiveDate = new Date(disbursementData.effectiveDate);
      disbursementData.applicantName = losData.customerName;
      disbursementData.customerId = losData.customerId;
      disbursementData.branch = losData.branch;
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.code === losData.branchCode;
      });
      disbursementData.branchCode = branchCodeValue.code;
      disbursementData.voucherNum = disbursementData.voucherNum;
      disbursementData.lastModifiedBy = userName;
      disbursementData.createdBy = disbursementData.createdBy;
      disbursementData.createdDate = disbursementData.createdDate;
      disbursementData.requestStatus = overAllDisbRecordStatus;
      setTimeout(() => {
        setLoading(false);
        const validatedData = [];
        validatedData.push(disbursementData);
        validatedData.push(losData);
        setsaveData(validatedData);
        setshowConfirmation(true);
      }, 1000);
    } else {
      setLoading(false);
    }
  };

  const updateDisbursementDataToDB = async (data, losData) => {
    try {
      setDisableSaveBtn(true);
      const response = await axios.post(
        "/disbursement/updateDisbursement",
        data
      );
      if (response.status === 200) {
        const spinnerMsg =
          props.screenMode === "CANCEL"
            ? "Disbursement Cancelled and updating Application Status ....."
            : props.screenMode === "MODIFY"
            ? "Disbursement Updated Successfully and updating Application Status ....."
            : "Disbursement Approved and updating Application Status.....";
        setLoadingMsg(spinnerMsg);
        if (data.screenMode === "CANCEL") {
          changeLosStatusOnCancel(losData, data);
          setsnackBarMessage("Disbursement Request Cancelled Successfully.");
        } else if (data.screenMode === "MODIFY") {
          setsnackBarMessage("Disbursement Request Modified Successfully.");
        } else {
          setLosStatus(losData, response.data);
          await saveAccrualDetails(response.data);
          setsnackBarMessage("Disbursement Request Approved Successfully.");
          const disbBalanceTransferRecords = response.data?.disbursementFavours;
          const validHostToHostRecordsForNeftorRtgs =
            disbBalanceTransferRecords.filter(
              (record) =>
                record.paymentMode === "NEFT" || record.paymentMode === "RTGS"
            );
          const validHostToHostRecordsForCheque =
            disbBalanceTransferRecords.filter(
              (record) =>
                record.paymentMode === "CHEQUE" &&
                record.chequeMode === "AUTO" &&
                record.chequePrintAt === "SHFL BRANCH"
            );
          if (
            props.screenMode === "APPROVE" &&
            (validHostToHostRecordsForNeftorRtgs.length > 0 ||
              validHostToHostRecordsForCheque.length > 0)
          ) {
            setLoadingMsg(
              "Initiating and Processing Host to Host Data Transfer ....."
            );
            getCsvData(disbBalanceTransferRecords);
          }
          // await processEnach(data);
        }
        setshowSnackBar(true);

        setTimeout(() => {
          setLoading(false);
          setDisableSaveBtn(false);
          const dataValue = { ...response.data };
          dataValue.screenMode = props.screenMode;
          if (props.screenMode === "CANCEL") {
            navigate("/stlap/home/disbursementList", { replace: true });
          } else {
            navigate("/stlap/home/disbursementView", {
              replace: true,
              state: dataValue,
            });
          }
        }, 2000);
      } else if (response.status === 206) {
        setLoading(false);
        setDisableSaveBtn(false);
        setTimeout(() => {
          navigate("/stlap/home/disbursementView", {
            replace: true,
            state: response.data,
          });
        }, 600);
      }
    } catch (error) {
      if (error.response.status === 400) {
        setsnackBarMessageColorType("red");
        setsnackBarMessageType("error");
        setsnackBarMessage(error.response.data);
        setshowSnackBar(true);
      }
      setLoading(false);
      setDisableSaveBtn(false);
      console.log(error);
    }
  };
  const processEnach = async (data) => {
    let newAxiosBaseValue = { ...axios };
    newAxiosBaseValue.defaults.baseURL =
      process.env.REACT_APP_STLAP_LMS_BACKEND;
    if (data.disbCycleNum === 1) {
      let requestResponse = await newAxiosBaseValue.post(
        "/disbursement/getDataForEnach",
        {
          applicationNum: losCustomerData.applicationNum,
        }
      );
      let newAxiosBase = { ...axios };
      newAxiosBase.defaults.baseURL =
        process.env.REACT_APP_ENACH_BACKEND_SERVER;
      let response = await newAxiosBase.post(
        "/enach/insertDataToEnach",
        requestResponse.data
      );
      if (response.status === 200) {
        console.log(response.data);
      } else {
        console.log("Fail to send a mail");
      }
    }
  };
  const confirmationOkClickHandler = () => {
    setshowConfirmation(false);
    const spinnerMsg =
      props.screenMode === "CANCEL"
        ? "Please Wait Requesting Disbursement Cancellation ....."
        : props.screenMode === "MODIFY"
        ? "Processing Disbursement Data for Updation ....."
        : "Please Wait Requesting Disbursement Approval .....";
    setLoading(true);
    setLoadingMsg(spinnerMsg);
    updateDisbursementDataToDB(saveData[0], saveData[1]);
  };

  const getCsvData = async (disbBalanceTransferRecords) => {
    const gridrecords = [...disbBalanceTransferRecords].map((row) => {
      let record = { ...row };
      record.id = record.disbAccountKey;
      record.amount = record.totalDisbAmt;
      record.disbAmt = record.disbAmt;
      record.favouringName = record.accHoldrName;
      record.bankBranchShflBank = record.bankBranch;
      if (record.docName && record.docData) {
        record.handOverFile = record.docName;
        const arrayFileString = String(record.docData).split(";base64,");
        const base64StringValue = arrayFileString[1];
        const fileType = arrayFileString[0].split("data:");
        const uploadedFile = ConvertBase64ToFile(
          base64StringValue,
          record.docName,
          fileType[1]
        );
        const fileData = Object.assign(uploadedFile, {
          preview: URL.createObjectURL(uploadedFile),
        });
        record.handOverFiles = [fileData];
      } else {
        record.handOverFile = null;
        record.handOverFiles = [];
      }
      return record;
    });
    const validHostToHostRecordsForNeftorRtgs = gridrecords.filter(
      (record) => record.paymentMode === "NEFT" || record.paymentMode === "RTGS"
    );
    const validHostToHostRecordsForCheque = gridrecords.filter(
      (record) =>
        record.paymentMode === "CHEQUE" &&
        record.chequeMode === "AUTO" &&
        record.chequePrintAt === "SHFL BRANCH"
    );
    let bankDetailsRecords = [];
    bankDetailsRecords = bankDetailsRecords.concat(
      validHostToHostRecordsForNeftorRtgs
    );
    bankDetailsRecords = bankDetailsRecords.concat(
      validHostToHostRecordsForCheque
    );
    let multiplePaymentModePayload = [];
    const branchNamesWithCodes = GetBranchDetailsWithCode();
    bankDetailsRecords.forEach((bankDetails, index) => {
      let paramMap = {};
      let transactionType = "";
      let ifscCode = bankDetails.ifscCode;
      let hdfcIfsc = "HDFC";
      let paymentMode = bankDetails.paymentMode;
      // for Neft or Rtgs
      if (
        (paymentMode === "RTGS" || paymentMode === "NEFT") &&
        ifscCode.indexOf(hdfcIfsc) === 0
      ) {
        transactionType = "I";
      } else {
        switch (paymentMode) {
          case "RTGS":
            transactionType = "R";
            break;
          case "NEFT":
            transactionType = "N";
            break;
          default:
            break;
        }
      }
      // for Cheque payment Mode
      if (paymentMode === "CHEQUE") {
        transactionType = "C";
      }

      let as = bankDetails.applicationNum;
      let dc = disbursementDetailTabValue.disbCycleNum;
      let instrumentRefNumber = `${as}/${dc}/${Number(index) + 1}`;
      paramMap.paymentMode = paymentMode;
      paramMap.transactionType = transactionType;
      paramMap.beneficiaryCode = ifscCode.indexOf(hdfcIfsc) === 0 ? "I" : "";
      paramMap.beneficiaryAccountNumber = bankDetails.bankAccountNum;
      let instrumentAmount = 0;
      if (transactionType === "R") {
        if (bankDetails.disbAmt > 200000) {
          instrumentAmount = bankDetails.disbAmt;
        }
      } else {
        instrumentAmount = bankDetails.disbAmt;
      }
      paramMap.instrumentAmount = instrumentAmount;
      if (paymentMode === "RTGS" || paymentMode === "NEFT") {
        paramMap.beneficiaryName = bankDetails.accHoldrName
          .trim()
          .substring(0, 40);
      } else {
        paramMap.beneficiaryName = bankDetails.accHoldrName.trim();
      }
      paramMap.applicationNumber = bankDetails.applicationNum;
      paramMap.draweeLocation = ""; //need to confirm
      paramMap.printLocation = "";
      paramMap.beneAddress1 = "";
      paramMap.beneAddress2 = "";
      paramMap.beneAddress3 = "";
      paramMap.beneAddress4 = "";
      paramMap.beneAddress5 = "";
      paramMap.instructionReferenceNumber = "";
      paramMap.customerReferenceNumber = instrumentRefNumber;
      paramMap.paymentDetails1 = "";
      paramMap.paymentDetails2 = "";
      paramMap.paymentDetails3 = "";
      paramMap.paymentDetails4 = "";
      paramMap.paymentDetails5 = "";
      paramMap.paymentDetails6 = "";
      paramMap.paymentDetails7 = "";
      paramMap.chequeNumber = 0; //""
      paramMap.chqTrnDate = dayjs(new Date()).format("DD/MM/YYYY"); //need to ask
      paramMap.micrNumber = 0; //""
      paramMap.ifcCode = bankDetails.ifscCode; //
      paramMap.beneBankName =
        paymentMode === "CHEQUE" ? "" : instrumentRefNumber;
      paramMap.beneBankBranchName = bankDetails.bankName;
      paramMap.beneficiaryEmailId = losCustomerData.emailId;
      paramMap.disbHeaderKey = bankDetails.disbHeaderKey;
      if (paymentMode === "CHEQUE") {
        paramMap.chequeNumber = bankDetails.chequeNum;
        paramMap.voucherReferenceNumber = disbursementDetailTabValue.voucherNum;
        const branchCodeValue = branchNamesWithCodes.find((branch) => {
          return branch.label === bankDetails.chequeShflLocation;
        });
        paramMap.paymentGridBranchName = branchCodeValue.label;
        paramMap.paymentGridBranchCode = branchCodeValue.code;
        paramMap.chqTrnDate = dayjs(new Date()).format("DD/MM/YYYY"); //need to ask
        paramMap.chequeDate = dayjs(new Date()).format("DD/MM/YYYY"); // need to confirm whether to bind cheque allocation date after new spec impl
      }
      paramMap.createdBy = userName;
      paramMap.createdDate = dayjs(new Date()).format("DD/MM/YYYY");
      multiplePaymentModePayload.push(paramMap);
    });

    const response = await axios.post("/hostToHostTransfer/insertDataToHost", {
      multiplePaymentModePayload,
    });
    // if (response.status === 200) {
    //   insertIntoCsv(bankDetails.applicationNum, response.data);
    // }
  };

  const insertIntoCsv = async (applicationNumber, data) => {
    let fileName = data.fileName;
    const response = await axios.get("/hostToHostTransfer/getFile", {
      method: "get",
      params: {
        applicationNumber: applicationNumber,
        fileName: fileName,
      },
      responseType: "blob",
    });
    if (response.status === 200) {
      let data = response.data;
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const removeEditLock = async (disbCycleNum, applicationNum, screenMode) => {
    const response = await axios.post("/disbursement/editLockUpdate", {
      disbCycleNum: disbCycleNum,
      applicationNum: applicationNum,
      screenMode: screenMode,
    });
  };

  const changeLosStatusOnCancel = async (losData, disbursementData) => {
    let updateModel = {};

    updateModel = {
      applicationNum: losData.applicationNum,
      disbCycleNum: disbursementData.disbCycleNum,
      losStatus:
        disbursementData.disbCycleNum === 1 ? "Sanctioned" : "Disbursed",
      userName: userName,
    };

    const response1 = await axios.post(
      "/losCustomer/updateCustomerData",
      updateModel
    );
  };

  const setLosStatus = async (losData, disbursementData) => {
    let updateModel = {};
    if (
      disbursementDetailTabValue.disbAmt +
        disbursementDetailTabValue.earlierDisbAmt ===
      losData.sanctionAmt
    ) {
      updateModel = {
        applicationNum: losData.applicationNum,
        disbCycleNum: 2,
        losStatus:
          disbursementData.requestStatus === "Approved"
            ? "Disbursement Completed"
            : "Requested",
        userName: userName,
      };
    } else {
      updateModel = {
        applicationNum: losData.applicationNum,
        disbCycleNum: 2,
        losStatus:
          disbursementData.requestStatus === "Approved"
            ? "Disbursed"
            : "Requested",
        userName: userName,
      };
    }

    const response1 = await axios.post(
      "/losCustomer/updateCustomerData",
      updateModel
    );
    updateDeductionsData();
  };

  const updateDeductionsData = async () => {
    const response1 = await axios.post(
      "/additionalfee/updateReceivedAmount",
      deductionTabSaveValue
    );
  };

  const saveAccrualDetails = async (dataValue) => {
    if (deductionTabValue.accrualTotal > 0) {
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.code === losCustomerData.branchCode;
      });
      const dataMap = {};
      const saveMap = {};
      dataMap["gridData"] = deductionTabValue.gridRows;
      deductionTabValue.gridRows.forEach((map, index) => {
        if (map["earlyWaiver"] + map["receiveable"] > 0) {
          saveMap[map["code"]] =
            map["receiveable"] - map["received"] - map["earlyWaiver"];
        }
      });
      dataMap["reason"] = "Additional Insurance Accrual From Disbursement";
      const dataValues = {
        ...disbursementDetailTabValue,
      };
      dataMap["remarks"] = dataValues.approvalRemarks;
      dataMap["refDate"] = `${new Date().getDate()}/${
        new Date().getMonth() + 1
      }/${new Date().getFullYear()}`;
      dataMap["referenceNumber"] = feeDataResponse.referenceNumber
        ? Number(feeDataResponse.referenceNumber) + 1
        : "1";
      dataMap["branch"] = losCustomerData.branch;
      dataMap["branchCode"] = branchCodeValue.code;
      dataMap["updatedBy"] = userName;
      dataMap["userName"] = userName;
      dataMap["applicationNum"] = location.state.applicationNum;
      dataMap["type"] = "paid";
      dataMap["historyData"] = { historyData };
      dataMap["saveMap"] = saveMap;
      dataMap["headerKey"] = dataValue.disbHeaderKey;
      dataMap["voucherNum"] = dataValue.voucherNum;
      const response = await axios.post(
        "/additionalfee/saveApprovedFeeDetails",
        dataMap
      );
    }
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const validateChequeDatesAtAuthorizationLevel = async (handoverDates) => {
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
        "Validating the Selected Records Cheque HandOver Dates across already existing Authorised Cheques."
      )
    );
    try {
      const response = await axios.post(
        "/disbursement/validateChequeHandoverDates",
        {
          applicationNum: losCustomerData.applicationNum,
          handoverDates: handoverDates,
        }
      );
      if (response.status === 200) {
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            "Processing Cheques Authorization since selected Cheque HandOver Dates are Valid ."
          )
        );
        setMessage(
          "Cheque HandOver Dates are Valid Processing Cheques Authorization."
        );
        setAlertType("success");
        openAlertHandler();
        return true;
      }

      if (response.status === 206) {
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            "Few Cheques HandOver Dates are Invalid Can't Proceed for Cheques Authorization."
          )
        );
        setMessage("Few Cheques HandOver Dates are Invalid.");
        setAlertType("error");
        openAlertHandler();
        return false;
      }
    } catch (error) {
      console.log(error);
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
          "Error In API processing " + error.message
        )
      );
      setMessage("Error In API processing " + error.message);
      setAlertType("error");
      openAlertHandler();
      return false;
    }
  };

  const validateChequeRecordsForAllocationOrAuthorization = async () => {
    const latestChequeHandOverOrAuthorizeDlgData =
      store.getState().disbursementBalanceTransfer
        .chequeHandOverOrAuthorizeDlgData;
    const chequeRows = latestChequeHandOverOrAuthorizeDlgData.dlgGridRows;
    // validate only selected rows for cheque date validation & hand over file validation.
    const selectedRows = chequeRows.filter((record) => record.isRowSelected);
    if (selectedRows.length === 0) {
      // no records to validate.
      setMessage("Please Select Some rows to Proceed.");
      setAlertType("error");
      openAlertHandler();
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
          false
        )
      );
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
          ""
        )
      );
      return;
    }
    if (
      latestChequeHandOverOrAuthorizeDlgData.dlgMode ===
      "CHEQUE_HANDOVER_ALLOCATION"
    ) {
      const invalidChequeHandOverDates = [...selectedRows].filter(
        (row) =>
          row.chequeHandoverDate === "" ||
          row.chequeHandoverDate === null ||
          row.chequeHandoverDate === undefined ||
          new Date(row.chequeHandoverDate).toDateString() === "Invalid Date"
      );

      if (invalidChequeHandOverDates.length > 0) {
        setMessage("Some rows have Invalid Cheque HandOver Date.");
        setAlertType("error");
        openAlertHandler();
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
            false
          )
        );
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            ""
          )
        );
        return;
      }
      const outOfRangeDates = [...selectedRows].filter((row) => {
        const value =
          new Date(row.chequeHandoverDate) < new Date("01/01/1970") ||
          new Date(row.chequeHandoverDate) > new Date("12/31/2055");
        return value;
      });

      if (outOfRangeDates.length > 0) {
        setMessage(
          "Some rows have Invalid Cheque Hand Over Date as either less than 1970 or greater than 2055."
        );
        setAlertType("error");
        openAlertHandler();
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
            false
          )
        );
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            ""
          )
        );
        return;
      }

      const invalidChequeHandOverFiles = [...selectedRows].filter(
        (row) =>
          !row.handOverFiles ||
          row.handOverFiles === undefined ||
          row.handOverFiles === null ||
          row.handOverFiles.length === 0
      );

      if (invalidChequeHandOverFiles.length > 0) {
        setMessage("Some rows have Zero Cheque HandOver Files Uploaded.");
        setAlertType("error");
        openAlertHandler();
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
            false
          )
        );
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            ""
          )
        );
        return;
      }

      const invalidChequeHandOverFileCountPerRow = [...selectedRows].filter(
        (row) =>
          row.handOverFiles &&
          row.handOverFiles !== undefined &&
          row.handOverFiles !== null &&
          row.handOverFiles.length > 1
      );

      if (invalidChequeHandOverFileCountPerRow.length > 0) {
        setMessage(
          "Some rows have More than 1 Cheque HandOver Files Uploaded."
        );
        setAlertType("error");
        openAlertHandler();
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
            false
          )
        );
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            ""
          )
        );
        return;
      }
    } else {
      // validate the cheque handover dates on Authorization level ->
      // such that Cheque Handover Date does not exceeds the current day Date Authorization Value.

      const currentDateValue = new Date(new Date().toDateString());

      const chequeHandOverDates = [...selectedRows].map(
        (row) => row.chequeHandoverDate
      );

      const invalidChequeHandOverDates = chequeHandOverDates.filter(
        (dateValue) => {
          const convertedChequeHandoverDate = new Date(dateValue);
          return (
            new Date(convertedChequeHandoverDate.toDateString()) >
            currentDateValue
          );
        }
      );

      if (invalidChequeHandOverDates.length > 0) {
        // means some handover dates are greater than current date Authorization Date.
        setMessage(
          "Some rows have Cheque HandoverDate Greater than Current Date on which Authorization is triggered."
        );
        setAlertType("error");
        openAlertHandler();
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
            false
          )
        );
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
            ""
          )
        );
        return;
      }

      // validation of cheque dates on Authorization of selected dates with already Authorised records.
      const validationFlag = await validateChequeDatesAtAuthorizationLevel(
        chequeHandOverDates
      );
      if (!validationFlag) {
        dispatch(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
            false
          )
        );
        return;
      }
    }

    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
        latestChequeHandOverOrAuthorizeDlgData.dlgMode ===
          "CHEQUE_HANDOVER_ALLOCATION"
          ? "Initiating Cheque HandOver Allocation for the Selected Cheques ....."
          : "Authorising the Selected Cheques ....."
      )
    );
    let apiUrl =
      latestChequeHandOverOrAuthorizeDlgData.dlgMode ===
      "CHEQUE_HANDOVER_ALLOCATION"
        ? "/disbursement/updateCheckHandover"
        : "/disbursement/updateCheckAuthourization";
    try {
      let updatedSelectedRows = [];
      for (const gridRow of selectedRows) {
        let row = { ...gridRow };
        // current spec is only 1 uploaded file is considered as valid for save.
        const file = row.handOverFiles ? row.handOverFiles[0] : null;
        const blob = await convertFileToBlob(file);
        row.docName = file.name; // gives the file name.
        row.docData = blob;
        updatedSelectedRows.push(row);
      }

      const disbRecordResponse = await axios.post(apiUrl, updatedSelectedRows);
      let dataValue = { ...disbRecordResponse.data };
      const successMsg =
        latestChequeHandOverOrAuthorizeDlgData.dlgMode ===
        "CHEQUE_HANDOVER_ALLOCATION"
          ? "Cheque HandOver Allocation Processed Successfully"
          : "Cheque Authorization done Successfully";
      setMessage(successMsg);
      setAlertType("success");
      openAlertHandler();
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
          successMsg
        )
      );
      // change the structure of the balance transfer grid.
      let balanceTransferRecords = dataValue.disbursementFavours;
      balanceTransferRecords = [...balanceTransferRecords].map((row) => {
        let record = { ...row };
        record.id = record.disbAccountKey;
        record.amount = record.totalDisbAmt;
        record.disbAmt = record.disbAmt;
        record.favouringName = record.accHoldrName;
        record.bankBranchShflBank = record.bankBranch;
        if (record.docName && record.docData) {
          record.handOverFile = record.docName;
          const arrayFileString = String(record.docData).split(";base64,");
          const base64StringValue = arrayFileString[1];
          const fileType = arrayFileString[0].split("data:");
          const uploadedFile = ConvertBase64ToFile(
            base64StringValue,
            record.docName,
            fileType[1]
          );
          const fileData = Object.assign(uploadedFile, {
            preview: URL.createObjectURL(uploadedFile),
          });
          record.handOverFiles = [fileData];
        } else {
          record.handOverFile = null;
          record.handOverFiles = [];
        }
        return record;
      });
      dataValue.disbursementFavours = balanceTransferRecords;
      dispatch({
        type: screenFields.requestStatus,
        value: dataValue.requestStatus,
      });

      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateGridRows(
          balanceTransferRecords
        )
      );
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          null
        )
      );
      setTimeout(() => {
        const dlgData = {
          dlgOpen: false,
          dlgMode: "",
          dlgModeLabel: "",
          spinnerFlag: false,
          spinnerText: "",
        };
        dispatchAction(
          DisbursementBalanceTransferReducerAction.updateChequeHandOverOrAuthorizeDlgData(
            dlgData
          )
        );
        const disbDataValue = { ...dataValue };
        if (disbDataValue.requestStatus === "Approved") {
          setLoading(true);
          setLoadingMsg("Updating Application status .....");
          setTimeout(() => {
            const disbData = { ...dataValue };
            const losDataValue = { ...losCustomerData };
            setLosStatus(losDataValue, disbData);
            setLoading(false);
            setLoadingMsg("");
          }, 2000);
        }
      }, 2000);
    } catch (error) {
      console.log(error);
      // stay on the Dialog for user Convience, don't destruct the data on dialog.
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
          false
        )
      );
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
          ""
        )
      );
      setMessage(error.message);
      setAlertType("error");
      openAlertHandler();
    }
  };

  const convertFileToBlob = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target && event.target.result);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      {!pageloading && (
        <>
          {!viewValue ? (
            <Box style={{ minHeight: "calc(100vh - 120px)" }}>
              <NoSpecialAccess />
            </Box>
          ) : (
            <Box style={{ minHeight: "calc(100vh - 120px)" }}>
              <DisbursementTabIntegrator
                billDayValues={billDayValues}
                deductionTabValue={deductionTabValue}
                setdeductionTabValue={setdeductionTabValue}
                historyData={historyData}
                setHistorydata={setHistorydata}
                disbursementDetailTabValue={disbursementDetailTabValue}
                screenMode={props.screenMode}
                screenFields={screenFields}
                dispatchEvent={dispatch}
                errordispatchEvent={errorDispatch}
                errorParameters={errorParameters}
                errorState={errorState}
                screenTitle={props.screenTitle}
                parameterValues={parameterValues}
                validateBalanceTransferGrid={validateBalanceTransferGrid}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "8px 0px 8px 0px",
                }}
              >
                <Tooltip title="Ctrl+Z" placement="top">
                  <CustomButton
                    sx={{ height: "2rem" }}
                    variant="contained"
                    disabled={disableSaveBtn}
                    ref={backRef}
                    onClick={async () => {
                      removeEditLock(
                        disbursementDetailTabValue.disbCycleNum,
                        disbursementDetailTabValue.applicationNum,
                        props.screenMode
                      );
                      if (
                        props.screenMode === "MODIFY" ||
                        props.screenMode === "CANCEL"
                      ) {
                        navigate("/stlap/home/disbursementList", {
                          replace: true,
                        });
                      } else {
                        navigate("/stlap/home/disbursementApprovalList", {
                          replace: true,
                        });
                      }
                    }}
                  >
                    Back to Search
                  </CustomButton>
                </Tooltip>

                {/* {disbursementDetailTabValue.requestStatus === "Approved" && (
                <CustomButton
                  sx={{
                    height: "2rem",
                    marginLeft: "1%",
                    backgroundColor: "black",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={() => {
                    const dataValue = { ...disbursementDetailTabValue };
                    dataValue.screenMode = props.screenMode;
                    navigate("/stlap/home/disbursement/repaymentStructure", {
                      replace: true,
                      state: dataValue,
                    });
                  }}
                >
                  Repayment Structure
                </CustomButton>
              )} */}

                {props.screenMode === "MODIFY" ? (
                  <Tooltip title="Ctrl+U" placement="top">
                    <CustomButton
                      sx={{ height: "2rem", marginLeft: "1%" }}
                      variant="contained"
                      disabled={
                        disableSaveBtn ||
                        deleteOperationActive ||
                        totalDeductionsTabLoadingActive
                      }
                      onClick={() => {
                        setLoading(true);
                        setLoadingMsg("Validating the Disbursement Data .....");
                        setTimeout(() => {
                          const dataValues = { ...disbursementDetailTabValue };
                          updateRequestHandler(dataValues, losCustomerData);
                        }, 1500);
                      }}
                      ref={saveRef}
                    >
                      Update Request
                    </CustomButton>
                  </Tooltip>
                ) : props.screenMode === "CANCEL" ? (
                  <Tooltip title="Ctrl+B" placement="top">
                    <CustomButton
                      sx={{ height: "2rem", marginLeft: "1%" }}
                      variant="contained"
                      disabled={
                        disableSaveBtn ||
                        deleteOperationActive ||
                        totalDeductionsTabLoadingActive
                      }
                      onClick={() => {
                        setLoading(true);
                        setLoadingMsg("Validating the Disbursement Data .....");
                        setTimeout(() => {
                          const dataValues = { ...disbursementDetailTabValue };
                          updateRequestHandler(dataValues, losCustomerData);
                        }, 1500);
                      }}
                      ref={deleteRef}
                    >
                      Cancel Request
                    </CustomButton>
                  </Tooltip>
                ) : (
                  <React.Fragment>
                    {disbursementDetailTabValue.requestStatus !==
                      "Approved , Cheque HandOver Pending" &&
                      disbursementDetailTabValue.requestStatus !==
                        "Approved , Cheque Authourization Pending" &&
                      disbursementDetailTabValue.requestStatus !==
                        "Approved" && (
                        <Tooltip title="Ctrl+U" placement="top">
                          <CustomButton
                            sx={{ height: "2rem", marginLeft: "1%" }}
                            variant="contained"
                            ref={approveRef}
                            disabled={
                              disableSaveBtn ||
                              deleteOperationActive ||
                              totalDeductionsTabLoadingActive
                            }
                            onClick={() => {
                              setLoading(true);
                              setLoadingMsg(
                                "Validating the Disbursement Data ....."
                              );
                              setTimeout(() => {
                                const dataValues = {
                                  ...disbursementDetailTabValue,
                                };
                                updateRequestHandler(
                                  dataValues,
                                  losCustomerData
                                );
                              }, 1500);
                            }}
                          >
                            Approve Request
                          </CustomButton>
                        </Tooltip>
                      )}
                    {(disbursementDetailTabValue.requestStatus ===
                      "Approved , Cheque HandOver Pending" ||
                      disbursementDetailTabValue.requestStatus ===
                        "Approved , Cheque Authourization Pending") && (
                      <CustomButton
                        sx={{ height: "2rem", marginLeft: "1%" }}
                        variant="contained"
                        disabled={
                          disableSaveBtn ||
                          deleteOperationActive ||
                          totalDeductionsTabLoadingActive
                        }
                        onClick={() => {
                          const dlgData = {
                            dlgOpen: true,
                            dlgMode: "CHEQUE_HANDOVER_ALLOCATION",
                            dlgModeLabel: "Cheque HandOver Allocation Records",
                            spinnerFlag: false,
                            spinnerText: "",
                          };
                          dispatchAction(
                            DisbursementBalanceTransferReducerAction.updateChequeHandOverOrAuthorizeDlgData(
                              dlgData
                            )
                          );
                        }}
                      >
                        Cheque Handover Allocation
                      </CustomButton>
                    )}
                    {(disbursementDetailTabValue.requestStatus ===
                      "Approved , Cheque HandOver Pending" ||
                      disbursementDetailTabValue.requestStatus ===
                        "Approved , Cheque Authourization Pending") && (
                      <CustomButton
                        sx={{ height: "2rem", marginLeft: "1%" }}
                        variant="contained"
                        disabled={
                          disableSaveBtn ||
                          deleteOperationActive ||
                          totalDeductionsTabLoadingActive
                        }
                        onClick={() => {
                          const dlgData = {
                            dlgOpen: true,
                            dlgMode: "CHEQUE_HANDOVER_AUTHORIZATION",
                            dlgModeLabel:
                              "Cheque HandOver Authorization Records",
                            spinnerFlag: false,
                            spinnerText: "",
                          };
                          dispatchAction(
                            DisbursementBalanceTransferReducerAction.updateChequeHandOverOrAuthorizeDlgData(
                              dlgData
                            )
                          );
                        }}
                      >
                        Cheque Handover Authorization
                      </CustomButton>
                    )}
                  </React.Fragment>
                )}
              </Box>
            </Box>
          )}
          <StlapFooter />
          <CustomConfirmationDialog
            dialogOpen={showConfirmation}
            onDialogClose={() => {
              setshowConfirmation(false);
            }}
            dialogTitle={"Confirmation"}
            dialogContent={dialogMessage}
            cancelButtonName={"Cancel"}
            hideCancelButton={false}
            okButtonName={"Yes"}
            onOkClick={confirmationOkClickHandler}
          />
          <CustomSnackBar
            showSnackbar={showSnackBar}
            autoHideDuration={3000}
            onClose={() => {
              setshowSnackBar(false);
            }}
            message={snackBarMessage}
            color={snackBarMessageColorType}
            severity={snackBarMessageType}
          />
          <Dialog
            open={chequeHandOverOrAuthorizeDlgData.dlgOpen}
            fullScreen
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>
              <h4>{chequeHandOverOrAuthorizeDlgData.dlgModeLabel}</h4>
            </DialogTitle>
            <DialogContent>
              {
                <React.Fragment>
                  <Paper
                    sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}
                  >
                    <h4>{chequeHandOverOrAuthorizeDlgData.dlgModeLabel}</h4>
                    <ChequeHandOverAllocationOrAuthorizeGrid
                      disbursementDetailTabValue={disbursementDetailTabValue}
                    />
                  </Paper>
                </React.Fragment>
              }
            </DialogContent>
            <DialogActions>
              <Tooltip title="Ctrl+Q" placement="top">
                <Button
                  onClick={() => {
                    const dlgData = {
                      dlgOpen: false,
                      dlgMode: "",
                      dlgModeLabel: "",
                      spinnerFlag: false,
                      spinnerText: "",
                    };
                    dispatchAction(
                      DisbursementBalanceTransferReducerAction.updateChequeHandOverOrAuthorizeDlgData(
                        dlgData
                      )
                    );
                  }}
                >
                  CANCEL
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+K" placement="top">
                <Button
                  disabled={
                    chequeHandOverOrAuthorizeDlgData?.dlgGridRows.length === 0
                  }
                  onClick={() => {
                    // validate records based on the mode & push the records to save api based on mode & close the dlg.
                    // in case of api error or backend error stay on dlg to retain loss.
                    const spinnerMsg =
                      chequeHandOverOrAuthorizeDlgData.dlgMode ===
                      "CHEQUE_HANDOVER_ALLOCATION"
                        ? "Validating Selected Cheque Records For Cheque HandOver Allocation....."
                        : "Initiating Cheque Authorization for the Selected Cheque Records .....";

                    dispatchAction(
                      DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerFlag(
                        true
                      )
                    );
                    dispatchAction(
                      DisbursementBalanceTransferReducerAction.updateChequeHandOverSpinnerText(
                        spinnerMsg
                      )
                    );
                    setTimeout(() => {
                      validateChequeRecordsForAllocationOrAuthorization();
                    }, 2000);
                  }}
                >
                  OK
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={alert}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
            onClose={closeAlertHandler}
          >
            <Alert
              onClose={closeAlertHandler}
              severity={alertType}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
        </>
      )}{" "}
    </>
  );
};

export default DisbursementModify;
